import { auth } from 'pages/components/AuthShell/AuthShell.styled';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  width: 100%;
  margin-top: 0;
  padding: 36px 28px 40px;
  box-sizing: border-box;
  background: ${auth.bg};
  border-top: 1px solid ${auth.line};
  color: ${auth.muted};
  font-family: ${auth.font};
  position: relative;
  z-index: 12;
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const Top = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;
  flex-wrap: wrap;
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;
`;

export const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BrandName = styled.div`
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${auth.text};
`;

export const BrandBlurb = styled.p`
  margin: 0;
  max-width: 32ch;
  font-size: 13.5px;
  line-height: 1.5;
  color: ${auth.muted};
`;

const navLinkCss = `
  font-size: 14px;
  font-weight: 500;
  color: ${auth.muted};
  text-decoration: none;
  transition: color 0.15s ease;
  &:hover {
    color: ${auth.text};
  }
`;

export const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 18px;
`;

export const NavLink = styled.a`${navLinkCss}`;

export const NavRouterLink = styled(Link)`${navLinkCss}`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
  align-items: center;
`;

export const MetaItem = styled.a`
  font-size: 13.5px;
  font-weight: 500;
  color: ${auth.purple};
  text-decoration: none;
  transition: opacity 0.15s ease;
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 18px;
  border-top: 1px solid ${auth.line};
  font-size: 13px;
`;

export const ByLine = styled.div`
  font-weight: 600;
  color: ${auth.muted};
`;

export const Copy = styled.div`
  color: ${auth.muted};
`;
